import React from "react";
import RootLayout from "./src/components/RootLayout";

export const wrapRootElement = ({ element, props }) => <RootLayout {...props} element={element} />;

const GATSBY_CONFIGURATION = process.env.GATSBY_CONFIGURATION || "boleron";

const getCookie = name => {
  if (typeof document === "undefined") return null;
  const cookies = document.cookie ? document.cookie.split("; ") : [];
  for (let i = 0; i < cookies.length; i += 1) {
    const [key, value] = cookies[i].split("=");
    if (key === name) return decodeURIComponent(value || "");
  }
  return null;
};

const loadScriptOnce = (id, src, attrs = {}) => {
  if (typeof document === "undefined") return null;
  if (document.getElementById(id)) return document.getElementById(id);
  const script = document.createElement("script");
  script.id = id;
  script.src = src;
  script.async = true;
  Object.entries(attrs).forEach(([key, value]) => {
    script.setAttribute(key, value);
  });
  document.head.appendChild(script);
  return script;
};

const initFacebookPixel = () => {
  if (typeof window === "undefined") return;
  if (window.fbq) return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  window.fbq("init", "627854864418543");
  window.fbq("track", "PageView");
  /* eslint-enable */
};

export const onInitialClientRender = () => {
  if (GATSBY_CONFIGURATION === "vivacom") {
    loadScriptOnce("jquery", "https://ajax.googleapis.com/ajax/libs/jquery/1.12.1/jquery.min.js");
    loadScriptOnce("userway", "https://cdn.userway.org/widget.js", { "data-account": "4rQJ0yC16o" });
  }

  if (GATSBY_CONFIGURATION === "boleron") {
    const hasUserAcceptedConsent = !!getCookie("boleron-google-consent");
    if (hasUserAcceptedConsent) {
      initFacebookPixel();
    }
  }
};
